/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetAiBudgetQueryResponse, GetAiBudgetPathParams, GetAiBudget400, GetAiBudget401, GetAiBudget403, GetAiBudget404, GetAiBudget409, GetAiBudget500 } from "../../types/platformBillingController/GetAiBudget.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAiBudget } from "../../client/platformBillingController/getAiBudget.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAiBudgetQueryKey = (organizationId: GetAiBudgetPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/platform-billing/ai-budget', params: {organizationId:organizationId} }] as const

export type GetAiBudgetQueryKey = ReturnType<typeof getAiBudgetQueryKey>

export function getAiBudgetQueryOptions(organizationId: GetAiBudgetPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAiBudgetQueryKey(organizationId)
        return queryOptions<GetAiBudgetQueryResponse, ResponseErrorConfig<GetAiBudget400 | GetAiBudget401 | GetAiBudget403 | GetAiBudget404 | GetAiBudget409 | GetAiBudget500>, GetAiBudgetQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAiBudget(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get AI budget breakdown (plan + top-up credits, native currency)
 * {@link /api/organizations/:organizationId/platform-billing/ai-budget}
 */
export function useGetAiBudget<TData = GetAiBudgetQueryResponse, TQueryData = GetAiBudgetQueryResponse, TQueryKey extends QueryKey = GetAiBudgetQueryKey>(organizationId: GetAiBudgetPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetAiBudgetQueryResponse, ResponseErrorConfig<GetAiBudget400 | GetAiBudget401 | GetAiBudget403 | GetAiBudget404 | GetAiBudget409 | GetAiBudget500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getAiBudgetQueryKey(organizationId)
         

         const query = useQuery({
          ...getAiBudgetQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAiBudget400 | GetAiBudget401 | GetAiBudget403 | GetAiBudget404 | GetAiBudget409 | GetAiBudget500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}